import Vue from 'vue'
import Router from 'vue-router'
import Login from '../pages/login/index.vue'
import FeedBack from '../pages/feedback/index.vue'
import HistoryList from '../pages/historylist/index.vue'
import HistoryDetail from '../pages/historydetail/index.vue'
import CreateSheet from '../pages/createsheet/index.vue'
import SubmitSucess from '../pages/submitsucess/index.vue'
import PersonalCenter from '../pages/personalcenter/index.vue'
import Pending from "../pages/pending/pending"
Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

const router =  new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/feedback',
      name: 'FeedBack',
      component: FeedBack
    },
    {
      path: '/historylist',
      name: 'HistoryList',
      component: HistoryList,  // 不加缓存,重新进入当前页面,不会返回到已定位位置
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/historylist/historydetail/:id',
      name: 'HistoryDetail',
      component: HistoryDetail
    },
    {
      path: '/createsheet/:ques',
      name: 'CreateSheet',
      component: CreateSheet
    },
    {
      path: '/submitsucess',
      name: 'SubmitSucess',
      component: SubmitSucess
    },
    {
      path: '/personalcenter',
      name: 'PersonalCenter',
      component: PersonalCenter
    },
    {
      path: '/pending',
      name: 'pending',
      component: Pending
    },
    {
      path: '/register',
      name: 'Register',
      component: resolve => (require(["@/pages/register/index.vue"], resolve))
    }
  ]
})
router.beforeEach((to, from, next) => {
  if (Vue.prototype.$cookies.get('token')) {
    if (to.path == "/" || to.path == "/login" ) {
      next("/feedback")
    } else {
      next();
    }
  } else {
    //如果是登录页面路径，就直接next()
    if (to.path === '/login'||to.path === '/register') {
      next();
    } else {
      next('/login');
    }
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js